React = require 'react'
_ = require 'underscore'
Util = require 'lib/util'
# Using `create_board` here to share strings with parent template
t = require('views/internal/recup-with-helpers')('create_board')

module.exports = class OrgChooserComponent extends React.Component
  displayName: 'OrgChooserComponent'

  componentDidMount: ->
    setTimeout (=> @chooserElem?.focus()), 10

  render: t.renderable ->
    { onSelect, orgs, selectedOrg } = @props
    onNoTeamClick = @onNoTeamClick.bind @

    setChooserElem = (elem) => @chooserElem = elem
    setSelectedElem = (elem) => @selectedElem = elem

    t.ul '.pop-over-list.org-chooser', { ref: setChooserElem, tabIndex: 0 }, ->
      t.li ->
        t.a {
          href: '#'
          onClick: onNoTeamClick
          ref: if !selectedOrg? then setSelectedElem
        }, ->
          t.format 'no team'
          if !selectedOrg?
            t.icon 'check'

      orgs.forEach (org) ->
        isSelected = selectedOrg? && org.model.id == selectedOrg.model.id

        t.li { key: org.model.id }, ->
          t.a {
            href: '#'
            onClick: (e) ->
              Util.stop e
              onSelect org
          }, ->
            t.text org.model.get 'displayName'
            if isSelected
              t.icon 'check'

  onNoTeamClick: (e) =>
    Util.stop e
    @props.onSelect null



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/org-chooser-component.coffee